import { render, staticRenderFns } from "./PT435MemberSendListParts.vue?vue&type=template&id=c27f0c9c&"
import script from "./PT435MemberSendListParts.vue?vue&type=script&lang=js&"
export * from "./PT435MemberSendListParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports